// extracted by css-extract-rspack-plugin
export default {"root":"Anchor-module__root___eWNjQ"};